import { render, staticRenderFns } from "./TjingPopup.vue?vue&type=template&id=333b252a&scoped=true"
import script from "./TjingPopup.vue?vue&type=script&lang=js"
export * from "./TjingPopup.vue?vue&type=script&lang=js"
import style0 from "./TjingPopup.vue?vue&type=style&index=0&id=333b252a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333b252a",
  null
  
)

export default component.exports